var map = {
	"./c1.png": 52,
	"./c10.png": 53,
	"./c11.png": 54,
	"./c12.png": 55,
	"./c13.png": 56,
	"./c14.png": 57,
	"./c15.png": 58,
	"./c16.png": 59,
	"./c2.png": 60,
	"./c3.png": 61,
	"./c4.png": 62,
	"./c5.png": 63,
	"./c6.png": 64,
	"./c7.png": 65,
	"./c8.png": 66,
	"./c9.png": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 673;